import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingOutlinedCircledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M11.333 5.367a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0" fill="currentColor" />
                <path
                    d="M8.667 7.867a.5.5 0 0 1 .5-.5h1.666a.5.5 0 0 1 .5.5v3.5H4.667v-1.334a.5.5 0 0 1 .5-.5h1.5V8.95a.5.5 0 0 1 .5-.5h1.5z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.667 8C.667 4.333 2.5.667 8 .667S15.333 4.333 15.333 8 13.5 15.333 8 15.333.667 11.667.667 8m1.2 0c0-1.655.416-3.182 1.326-4.273C4.07 2.673 5.538 1.867 8 1.867c2.461 0 3.93.806 4.807 1.86.91 1.091 1.326 2.618 1.326 4.273s-.416 3.182-1.326 4.273c-.878 1.054-2.346 1.86-4.807 1.86s-3.93-.806-4.807-1.86C2.283 11.182 1.867 9.655 1.867 8"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
EmployersRatingOutlinedCircledSize16Glyph.displayName = 'EmployersRatingOutlinedCircledSize16Glyph';
